import ActionType from '../actions/ActionType'
// import { omit } from 'lodash'

export default (
  state = {
    drawerOpen: false,
    multiExpansionPanels: {},
    errorOpen: false,
    stepper: {
      campaign: 0,
      task: 0,
      template: 0,
      form: 0,
      pricing: 0,
    },
    count: null,
    profileDialogOpen: false,
    imageDialogOpen: false,
    deletePersonalDataDialogOpen: false,
    loadingDialogOpen: false,
    dialogs: {},
    forceUpdateCounter: 0,
  },
  action,
) => {
  switch (action.type) {
    case 'View.FORCE_LIST_UPDATE':
      return {
        ...state,
        forceUpdateCounter: state.forceUpdateCounter + 1,
      }
    case ActionType.View.TOGGLE_DIALOG:
      if (typeof state.dialogs[action.payload?.dialog] === 'undefined') {
        return {
          ...state,
          dialogs: {
            ...state.dialogs,
            [action.payload?.dialog]: {
              open:
                typeof action.payload?.open !== 'undefined'
                  ? action.payload.open
                  : true,
              ...(action.payload?.options || {}),
            },
          },
        }
      }

      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          [action.payload?.dialog]:
            typeof action.payload?.open === 'boolean'
              ? {
                  open: action.payload.open,
                  ...(action.payload?.options || {}),
                }
              : {
                  open: !state.dialogs[action.payload?.dialog]?.open,
                  ...(action.payload?.options || {}),
                },
        },
      }
    case ActionType.View.UPDATE_COUNT:
      return {
        ...state,
        count: action.payload,
      }
    case ActionType.View.CLOSE_DRAWER:
      return {
        ...state,
        drawerOpen: false,
      }
    case ActionType.View.OPEN_DRAWER:
      return {
        ...state,
        drawerOpen: true,
      }
    case ActionType.View.TOGGLE_DRAWER:
      return {
        ...state,
        drawerOpen: !state.drawerOpen,
      }
    case ActionType.View.SET_EXPANSION_PANELS:
      return {
        ...state,
        multiExpansionPanels: action.payload,
      }
    case ActionType.View.TOGGLE_MULTI_EXPANSION_PANEL:
      const multiExpansionPanels = state.multiExpansionPanels[action.payload]
        ? { ...state.multiExpansionPanels, [action.payload]: false }
        : { ...state.multiExpansionPanels, [action.payload]: true }

      return {
        ...state,
        multiExpansionPanels,
      }
    case ActionType.View.UPDATE_EXPANSION_PANELS:
      return {
        ...state,
        multiExpansionPanels: {
          ...state.multiExpansionPanels,
          ...action.payload,
        },
      }
    case ActionType.View.CLOSE_ERROR:
      return {
        ...state,
        error: false,
      }
    case ActionType.Contacts.CREATE_GROUP_FAILURE:
      return {
        ...state,
        error: 'Unable to create group. Possible duplicate name.',
      }
    case ActionType.View.STEPPER_INCREASE:
      return {
        ...state,
        stepper: {
          ...state.stepper,
          [action.stepperType]: state.stepper[action.stepperType] + 1,
        },
      }
    case ActionType.View.STEPPER_DECREASE:
      return {
        ...state,
        stepper: {
          ...state.stepper,
          [action.stepperType]: state.stepper[action.stepperType] - 1,
        },
      }
    case ActionType.View.STEPPER_GO_TO:
      return {
        ...state,
        stepper: {
          ...state.stepper,
          [action.stepperType]: action.payload,
        },
      }
    case ActionType.View.OPEN_PROFILE_DIALOG:
      return {
        ...state,
        profileDialogOpen:
          typeof action.payload === 'boolean'
            ? action.payload
            : !state.profileDialogOpen,
      }
    case ActionType.View.OPEN_IMAGE_DIALOG:
      return {
        ...state,
        imageDialogOpen:
          typeof action.payload === 'boolean' ||
          typeof action.payload === 'string'
            ? action.payload
            : !state.imageDialogOpen,
      }
    case ActionType.View.OPEN_DELETE_PERSONAL_DATA_DIALOG:
      return {
        ...state,
        deletePersonalDataDialogOpen:
          typeof action.payload === 'boolean' ||
          typeof action.payload === 'string'
            ? action.payload
            : !state.deletePersonalDataDialogOpen,
      }
    case ActionType.View.OPEN_LOADING_DIALOG:
      return {
        ...state,
        loadingDialogOpen:
          typeof action.payload === 'boolean' ||
          typeof action.payload === 'string'
            ? action.payload
            : !state.loadingDialogOpen,
      }
    default:
      return state
  }
}
